import { render, staticRenderFns } from "./ModalGerenciarVagasCriancas.vue?vue&type=template&id=321af5c2"
import script from "./ModalGerenciarVagasCriancas.vue?vue&type=script&lang=js"
export * from "./ModalGerenciarVagasCriancas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports